module.exports = __webpack_public_path__ + "static/media/mob-banner.9e7cddac.jpg";